<template>
  <div class="skeleton-table" :class="show ? '' : 'skeleton-table--hidden'">
    <div class="wrapper">
      <div class="row-area" v-for="(item, index) in rowCount" :key="index">
        <div class="line-row">
          <div class="row-li ">
            <div class="col">
              <div
                class="item"
                style="width: 36px;height: 36px;border-radius: 50%;"
              ></div>
            </div>
            <div class="col">
              <div
                class="item"
                style="width: 90px;height: 17px;margin-top: 0px;"
              ></div>
              <div
                class="item"
                style="width: 90px;height: 14px;margin-top: 4px;"
              ></div>
            </div>
            <div class="col">
              <div
                class="item"
                style="width: 110px;height: 30px;margin-top: 0px;"
              ></div>
            </div>
            <div class="col">
              <div
                class="item"
                style="width: 200px;height: 17px;margin-top: 0px;"
              ></div>
              <div
                class="item"
                style="width: 200px;height: 14px;margin-top: 4px;"
              ></div>
            </div>
            <div class="col">
              <div
                class="item"
                style="width: 80px;height: 14px;margin-top: 0px;"
              ></div>
            </div>
            <div class="col">
              <div
                class="item"
                style="width: 150px;height: 17px;margin-top: 0px;"
              ></div>
              <div
                class="item"
                style="width: 150px;height: 14px;margin-top: 4px;"
              ></div>
            </div>
            <div class="col" style="justify-self:flex-end;">
              <div
                class="item"
                style="width: 250px;height: 17px;margin-top: 0px;"
              ></div>
              <div
                class="item"
                style="width: 250px;height: 14px;margin-top: 4px;"
              ></div>
            </div>
            <div class="col" style="justify-self:flex-end;">
              <div
                class="item"
                style="width: 50px;height: 20px;margin-top: 0px;"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    // 默认循环行数
    rowCount: {
      type: Number,
      default: 1
    },
    // 单色双色
    rowColorNum: {
      type: Number,
      default: 1
    }
  },
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style scoped lang="scss">
// 骨架动画
@keyframes skeleton-ani {
  0% {
    opacity: 0.2;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
  }
}
@mixin skeletonAni {
  animation: skeleton-ani 3s ease 0s infinite normal both;
}
@keyframes skeleton-image-ani {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 0;
  }
}
.skeletonImageAni {
  animation: skeleton-image-ani 3s ease 0s infinite normal both;
}
@mixin tableRowGrid {
  display: grid;
  grid-template-columns:
    123/1200 * 100%
    104/1200 * 100%
    127/1200 * 100%
    220/1200 * 100%
    130/1200 * 100%
    161/1200 * 100%
    260/1200 * 100%
    1fr;
  .col {
    &:first-child {
      padding-left: 10px;
    }
    &:last-child {
      padding-right: 10px;
    }
  }
}

.skeleton-table {
  width: 100%;
  box-sizing: border-box;
  height: 58px;
  transition: all 0.35s;
  overflow: hidden;

  .wrapper {
    width: 100%;
    box-sizing: border-box;

    .row-area {
      width: 100%;
      .line-row {
        width: 100%;
        height: 58px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: #fff;
        .row-li {
          width: 100%;
          @include tableRowGrid();
          .col {
            align-self: center;
          }
        }
      }
    }
    // 通用样式
    .item {
      @include skeletonAni();
      flex: 0 0 auto;
      background: #e9ecf2;
    }
  }
}

.skeleton-table--hidden {
  height: 0px;
}
</style>
